var render = function render(){var _vm=this,_c=_vm._self._c;return _c('inline-svg',{staticClass:"icon",class:_vm.iconClass,attrs:{"width":"14","height":"14","src":require(`../assets/icons/${_vm.name}.svg`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }